import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const HireFill = class extends React.Component {
  render() {
    return (
      <section className="home-where">
        <div className="role">
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.h2
                ref={ref}
                initial={{ opacity: 0, transform: "translate(-50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                Looking To Hire?
              </motion.h2>
            )}
          </InView>
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.p
                ref={ref}
                initial={{ opacity: 0, transform: "translate(-50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                Finding the right people and skills to expand your business,
                increase capabilities, or a successor to an existing role can
                take up a lot of valuable time. We at Opal, specialise in
                finding our clients the perfect fit, giving you the freedom to
                focus on what matters most.
              </motion.p>
            )}
          </InView>
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, transform: "translate(-50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                <a href="#contact-form" data-scroll-to className="button-alt">
                  Fill a Roll
                </a>
              </motion.div>
            )}
          </InView>
        </div>
        <div className="hire">
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.h2
                ref={ref}
                initial={{ opacity: 0, transform: "translate(50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                Looking To Move?
              </motion.h2>
            )}
          </InView>
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.p
                ref={ref}
                initial={{ opacity: 0, transform: "translate(50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                We help our candidates take the next steps in their careers.
                Whether you’re looking for a new challenge, to specialise, or
                you’re moving somewhere new, we’ll work closely with you to
                ensure that your skills get the recognition they deserve.
              </motion.p>
            )}
          </InView>
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, transform: "translate(50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                <a href="#get-hired" data-scroll-to className="button">
                  Get Hired
                </a>
              </motion.div>
            )}
          </InView>
        </div>
      </section>
    );
  }
};

export default HireFill;
